/**
 * Decodes hash path segments from parent/shell payloads (may be multiply encoded).
 * Used by LOCATION_HASH_CHANGE handling and SMM OAuth redirect stub detection.
 */
export function decodeHashPathForRouting(rawPath: string): string {
  let decodedPath = rawPath;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    try {
      const nextDecodedPath = decodeURIComponent(decodedPath);
      if (nextDecodedPath === decodedPath) break;
      decodedPath = nextDecodedPath;
    } catch {
      break;
    }
  }
  return decodedPath;
}

/** Decoded pathname placeholders NGP uses after Facebook/Instagram OAuth (post–GUTS-6869 decode). */
const DECODED_OAUTH_STUB_PATHS = new Set(['/_', '/_=_', '/*=*']);

/** Encoded placeholders as sent in locationHash before in-app decode. */
const ENCODED_OAUTH_STUB_PATHS = new Set(['/_%3D_', '/*%3D*']);

/**
 * True when the pathname is the temporary OAuth callback stub (encoded or decoded).
 * @see App.tsx handleRedirectIssue
 */
export function isSocialMediaOAuthRedirectStubPathname(pathname: string | undefined | null): boolean {
  if (!pathname) {
    return false;
  }
  if (ENCODED_OAUTH_STUB_PATHS.has(pathname) || DECODED_OAUTH_STUB_PATHS.has(pathname)) {
    return true;
  }
  // Multiply-encoded or variant shell payloads (e.g. /_%253D_) that decode to /_=_ or /*=*.
  return DECODED_OAUTH_STUB_PATHS.has(decodeHashPathForRouting(pathname));
}
